
import React, { useState, useMemo, useEffect } from 'react'
import { IconButton, Button, Typography, MenuItem } from '@mui/material'
import { useScreenersContext } from '../context/useScreenersContext'
import { ArrowDropDown, Clear } from '@mui/icons-material'
import PopoverMenu from '../../ui/menuPopover/MenuPopover'
import DeleteScreenerModal from './DeleteScreenerModal'
import styles from './Screener.module.scss'

const MyScreensDropdown = ({selectedScreener, setSelectedScreener}) => {
    const { screeners, handleCreateNewScreener, handleRemoveScreener } = useScreenersContext()
    const [ anchorEl, setAnchorEl ] = useState(null)
    const [ itemToDelete, setItemToDelete ] = useState(null)
    const selectOptions = useMemo(() => screeners.map(screener => ({value: screener.uuid, name: screener.name})) ,[screeners])

    useEffect(() =>{ 
        !selectedScreener && selectOptions?.length && setSelectedScreener(selectOptions[0].value)
        return () => {}
    }, [selectOptions, selectedScreener, setSelectedScreener])

    const handleOpenScreens = (e) => setAnchorEl(e.currentTarget)

    const handleCloseScreens = () => setAnchorEl(null)

    const handleChangeScreener = (e) => {
        setSelectedScreener(e.target.attributes.value.value)
        handleCloseScreens()
    }

    const openDeleteMassgeModal = (e) => {
        e.stopPropagation()
        setItemToDelete({uuid:e.currentTarget.value, name: e.currentTarget.name})
        handleCloseScreens()
    }

    const handleCloseModal = () => setItemToDelete(null)

    const handleClickOnCreateNewScreener = () => {
        handleCloseScreens()
        handleCreateNewScreener()
    }

    return (
        <>
            <Button onClick={handleOpenScreens}>
                <Typography variant='h2' classes={{root: styles['select-screeners']}}> My Screens </Typography> <ArrowDropDown/>
            </Button>
            <PopoverMenu
            anchorEl={anchorEl}
            onClose={handleCloseScreens}>
                <div className={styles['screeners-menu']}>
                    {selectOptions.map(({value, name}) => <MenuItem classes={{root: styles['screeners-menu-item']}} key={value} value={value} onClick={handleChangeScreener}>
                        {name}
                        <IconButton 
                            value={value} 
                            name={name} 
                            onClick={openDeleteMassgeModal}
                        >
                            <Clear fontSize='small'/>
                        </IconButton>
                    </MenuItem>)}
                    <MenuItem key='create-new-screener' classes={{root: styles['create-new-screener']}} onClick={handleClickOnCreateNewScreener}>+ Create new Screener</MenuItem>
                </div>
            </PopoverMenu>
            {itemToDelete && <DeleteScreenerModal open={!!itemToDelete} {...itemToDelete} handleClose={handleCloseModal} handleDeleteScreener={handleRemoveScreener}/>}
        </>
    )
}

export default MyScreensDropdown